export const COUNTRY_GERMANY_URL = "https://www.dkms.de/";
export const COUNTRY_USA_URL = "https://www.dkms.org/";
export const COUNTRY_UK_URL = "https://www.dkms.org.uk/";
export const COUNTRY_POLAND_URL = "https://www.dkms.pl/";
export const COUNTRY_CHILE_URL = "https://www.dkms.cl/";
export const COUNTRY_INDIA_URL = "https://www.dkms-bmst.org/";
export const COUNTRY_AFRICA_URL = "https://dkms-africa.org/";
